import React from "react";
import { CreateNFeContext } from "../../../../Context";
export function useSetFinNFe() {
  const context = React.useContext(CreateNFeContext);
  const setFinNFe = (e) => {
    const { nfe } = context;
    nfe.identification.fin_nfe = e.value;
    context.handlers.updateNFeData(nfe);
  };
  return setFinNFe;
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/FinNFe/hooks/index.js